@if (queryProperty && queryProperties && queryProperties.length > 0) {
	@if (queryProperty.type == queryPropertyType.Select) {
		<custom-select
		[placeholder]="'query.select-placeholder' | translate"
		[selectList]="selectList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.customProperty == queryCustomType.TaskTemplateTag) {
		<custom-select
		[placeholder]="'query.task-template-tag-placeholder' | translate"
		[selectList]="taskTemplateTagList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.customProperty == queryCustomType.TaskflowTemplateTag) {
		<custom-select
		[placeholder]="'query.taskflow-template-tag-placeholder' | translate"
		[selectList]="taskflowTemplateTagList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.customProperty == queryCustomType.ProductPlanTag) {
		<custom-select
		[placeholder]="'query.product-plan-tag-placeholder' | translate"
		[selectList]="productPlanTagList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.customProperty == queryCustomType.ProductTag || queryProperty.customProperty == queryCustomType.OrderLineProductTag) {
		<custom-select
		[placeholder]="'query.product-tag-placeholder' | translate"
		[selectList]="productTagList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.type == queryPropertyType.InputTaskAreaId) {
		<custom-select
		[placeholder]="'query.task-area-placeholder' | translate"
		[selectList]="taskAreaList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.type == queryPropertyType.InputTeamId) {
		<custom-select
		[placeholder]="'query.assigned-user-placeholder' | translate"
		[selectList]="userTeamList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.type == queryPropertyType.InputReasonId) {
		<custom-select
		[placeholder]="'query.reason-placeholder' | translate"
		[selectList]="reasonList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.type == queryPropertyType.InputUserId) {
		<custom-select
		[placeholder]="'query.reference-users-placeholder' | translate"
		[selectList]="usersList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.type == queryPropertyType.Query) {
		<custom-select
		[placeholder]="'query.saved-query-placeholder' | translate"
		[selectList]="savedQueryList"
		[value]="value"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.customProperty == queryCustomType.TaskActionOnActiveStep) {
		<custom-select
		[placeholder]="'query.task-action-on-active-step-placeholder' | translate"
		[selectList]="selectList"
		[value]="value"
		[required]="true"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.valueType == queryPropertyValueType.Boolean) {
		<custom-select
		[placeholder]="'query.boolean-placeholder' | translate"
		[selectList]="booleanList"
		[value]="value?.toString()"
		(valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.valueType == queryPropertyValueType.Text) {
		<custom-input [inputType]="inputTypeEnum.Text" [value]="value" (valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.valueType == queryPropertyValueType.Numeric) {
		<custom-input [inputType]="inputTypeEnum.Number" [value]="value" (valueChange)="updateValue($event)" />
	}
	@else if (queryProperty.valueType == queryPropertyValueType.Date || queryProperty.valueType == queryPropertyValueType.DateTime) {
		<date-input [value]="dateValue" (valueChange)="updateValue($event)" />
	}
}
